import errorImage1 from "img/error_image_1.svg";
import { ImageNotifyErrorImage } from "../styles";
import CodeIcon from "icons/CodeIcon";
import PeopleIcon from "icons/PeopleIcon";
import AttendanceIcon from "icons/AttendanceIcon";

export const HEADERS_TABLE_LIST = [
    { title: "Código de alumno", icon: <CodeIcon/> },
    { title: "Apellidos y Nombres", icon: <PeopleIcon/> },
    { 
        title: "Asistencia", 
        icon: <AttendanceIcon/>
    }
];
export const DIALOGS_ALERT_CHECKTIME = {
    minWidth: "560px",
    buttonProps: {
        ok: {
            text: "Sí, marcar",
            width: "95px",
            size: "medium"
        },
        cancel: {
            variant: "secondary",
            text: "Cancelar",
            width: "95px",
            size: "medium"
        }
    }
};
export const PROPS_CONTENT_DIALOG_ALERT_NOTIFY_NOT_CHECKED_TIME_TO_STUDENT_ATTENDANCE = {
    image: <ImageNotifyErrorImage src={errorImage1} alt="Imagen error en UTP"/>,
    title: "No puedes marcar tu salida",
    value: "Recuerda que debes tomar la asistencia de los estudiantes antes de marcar tu salida.",
};
export const INIT_INFO_TUTOR_ATTENDANCE = {
    // checkInTime: "16:14:32",
    // checkOutTime: "17:15:12",
    // classTime: "61 minutos"
    checkInTime: "",
    checkOutTime: "",
    classTime: ""
};